<div class="page-body">
    <section>
        <label class="title-table-style">
            {{ 'cf-document.label.title' | translate }}
        </label>
        <div>
            <p class="document-not-loaded">{{ 'cf-document.notification.documentNotLoaded' | translate }}</p>
        </div>
    </section>
    <section>
        <kendo-appbar position="top" class="search-bar">
            <kendo-appbar-section>
                <label class="padding-right-10">{{ 'cf-document.control.module' | translate }}</label>
                <kendo-dropdownlist
                    [data]="documentTypes"
                    [(ngModel)]="documentStoreService.selectedDocumentType"
                    [valuePrimitive]="true"
                    textField="value"
                    valueField="key"
                    style="width: 150px">
                </kendo-dropdownlist>
            </kendo-appbar-section>

            <kendo-appbar-section>
                <label class="padding-right-10">{{ 'cf-document.control.documentNumber' | translate }}</label>
                <kendo-textbox
                    [style.width.px]="150"
                    [(value)]="documentStoreService.documentNumber"
                    (blur)="onDocumentNumberBlur()"
                    [disabled]="!isDocumentTypeSelected()"></kendo-textbox>
            </kendo-appbar-section>

            <kendo-appbar-section>
                <label class="padding-right-10">{{ 'cf-document.control.companyId' | translate }}</label>
                <kendo-textbox
                    [style.width.px]="150"
                    [(value)]="documentStoreService.companyId"
                    (blur)="onCompanyIdBlur()"
                    [disabled]="!isDocumentTypeSelected()"></kendo-textbox>
            </kendo-appbar-section>

            <kendo-appbar-section>
                <div></div>
                <button kendoButton (click)="onSearch()" [primary]="true" [disabled]="!documentStoreService.areFiltersValid()">
                    {{ 'cf-document.button.search' | translate }}
                </button>
            </kendo-appbar-section>
        </kendo-appbar>
    </section>
    <section *ngIf="!errorMessage; else undefinedDocument" style="height: 100%">
        <div *ngIf="isDocumentLoaded" class="document-details {{ leftSideExpanded ? '' : 'collpased' }}">
            <section *ngIf="leftSideExpanded" class="section-scrollable">
                <clfl-document-info-section [document]="document"></clfl-document-info-section>
                <div class="grid-title margin-top-20">{{ 'cf-document.grid.available-actions-section' | translate }}</div>

                <clfl-signatures
                    [unsignedSections]="getUnsignedSections()"
                    [participants]="document.participants"
                    [disabled]="!anyUnsignedSection() || isDocumentCanceled()"
                    (onSign)="openSignDialog()"
                    (onLoading)="setLoadingState($event)"></clfl-signatures>

                <clfl-company-tasks
                    [isDocumentCanceled]="isDocumentCanceled()"
                    (onRegisterEvent)="openRegisterEventDialog($event)"></clfl-company-tasks>
            </section>
            <section class="divider" (click)="expandColapseLeftSide()">
                <div class="divider-button">
                    <svg *ngIf="leftSideExpanded" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 1L1 5L5 9" stroke="#2B2D42" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <svg *ngIf="!leftSideExpanded" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5 5L1 9" stroke="#2B2D42" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </section>
            <section>
                <kendo-tabstrip class="tabstrip">
                    <kendo-tabstrip-tab [selected]="true">
                        <ng-template kendoTabTitle>
                            <kendo-svg-icon class="margin-right-5" [icon]="calendarIcon"></kendo-svg-icon>
                            {{ 'cf-document.tab.events.title' | translate }}
                        </ng-template>
                        <ng-template kendoTabContent>
                            <clfl-events-tab
                                [events]="events"
                                (onRefresh)="getEvents()"
                                (onFileDownload)="onFileDownload($event)"></clfl-events-tab>
                        </ng-template>
                    </kendo-tabstrip-tab>
                    <kendo-tabstrip-tab>
                        <ng-template kendoTabTitle>
                            <kendo-svg-icon class="margin-right-5" [icon]="filePdfIcon"></kendo-svg-icon>
                            {{ 'cf-document.tab.files.title' | translate }}
                        </ng-template>
                        <ng-template kendoTabContent>
                            <clfl-document-files-tab
                                [documentFiles]="documentFiles"
                                (onRefresh)="getDocumentVersions()"
                                (onFileDownload)="onFileDownload($event)"></clfl-document-files-tab>
                        </ng-template>
                    </kendo-tabstrip-tab>
                    <kendo-tabstrip-tab>
                        <ng-template kendoTabTitle>
                            <kendo-svg-icon class="margin-right-5" [icon]="copyIcon"></kendo-svg-icon>
                            {{ 'cf-document.tab.attachments.title' | translate }}
                        </ng-template>
                        <ng-template kendoTabContent>
                            <clfl-attachment-files-tab
                                [attachmentFiles]="attachmentFiles"
                                (onRefresh)="getAttachmentFiles()"
                                (onFileDownload)="onFileDownload($event)"></clfl-attachment-files-tab>
                        </ng-template>
                    </kendo-tabstrip-tab>
                </kendo-tabstrip>
            </section>
        </div>
    </section>
</div>

<ng-container *ngIf="isSignWithPinDialogOpened">
    <clfl-sign-with-pin-code
        [document]="document"
        [isOpened]="isSignWithPinDialogOpened"
        (isOpenedChange)="onSearch(); isSignWithPinDialogOpened = $event"
        (confirmAction)="onSearch(); isSignWithPinDialogOpened = false"
        (onLoading)="setLoadingState($event)">
    </clfl-sign-with-pin-code>
</ng-container>

<ng-container *ngIf="isSignOnGlassDialogOpened">
    <clfl-sign-on-glass
        [document]="document"
        [isOpened]="isSignOnGlassDialogOpened"
        (isOpenedChange)="onSearch(); isSignOnGlassDialogOpened = $event"
        (confirmAction)="onSearch(); isSignOnGlassDialogOpened = false"
        (onLoading)="setLoadingState($event)">
    </clfl-sign-on-glass>
</ng-container>

<ng-container *ngIf="isEventRegistrationDialogOpened">
    <clfl-register-event
        [isOpened]="isEventRegistrationDialogOpened"
        [task]="selectedTask"
        (isOpenedChange)="isEventRegistrationDialogOpened = $event"
        (confirmAction)="onSearch(); isEventRegistrationDialogOpened = false"
        (onLoading)="setLoadingState($event)">
    </clfl-register-event>
</ng-container>

<div class="loader" *ngIf="isLoading && !errorMessage">
    <div class="grid-loading-container">
        <kendo-loader type="converging-spinner" themeColor="info" size="medium"> </kendo-loader>
    </div>
</div>

<ng-template #undefinedDocument>
    <p class="document-not-found">{{ 'cf-document.notification.documentError' | translate }}</p>
</ng-template>
